import HeapData from './HeapData';

export { HeapData };
